import React from "react";
// import MapOne from "./first/MapOne";
export default function Map() {
  return <div style={{ width: "1300px" }}>{/* <MapOne /> */}</div>;
}
